import { IntlActions } from 'react-redux-multilingual'

import * as actionTypes from './actionTypes'
import { enqueueSnackbar } from './alert'
import baseAxios from '../../axios/base'
import userAxios from '../../axios/user'

export const signIn = credentials => {
  return dispatch => {
    dispatch(signInStart())
    let language = credentials.language ? credentials.language : 'en'

    baseAxios
      .post('/login', { ...credentials })
      .then(response => {
        if (response.status === 200) {
          let { token, user, permission } = response.data

          localStorage.setItem('language', language)
          dispatch(IntlActions.setLocale(language))

          // if (saveToken) {
          localStorage.setItem('authToken', JSON.stringify(token))
          localStorage.setItem('userInfo', JSON.stringify(user))
          localStorage.setItem('userPermissions', JSON.stringify(permission))
          // }

          sessionStorage.setItem('authToken', JSON.stringify(token))

          dispatch(signInSuccess(token, user, permission))
        }
      })
      .catch(error => {
        switch (error.response?.status) {
          case 401:
            dispatch(
              enqueueSnackbar({
                message: '401LI',
                options: {
                  variant: 'error'
                }
              })
            )
            break
          default:
            break
        }
        dispatch(signInFailed())
      })
  }
}

export const signInStart = () => {
  return {
    type: actionTypes.SIGNIN_START
  }
}

export const signInSuccess = (token, userInfo, userPermissions) => {
  return {
    type: actionTypes.SIGNIN_SUCCESS,
    token,
    userInfo,
    userPermissions
  }
}

export const signInFailed = errorMessage => {
  return {
    type: actionTypes.SIGNIN_FAILED,
    errorMessage
  }
}

export const forgotPass = credentials => {
  const params = { ...credentials }
  return dispatch => {
    dispatch(forgotPassStart())
    userAxios
      .post('/resetPassword', { params })
      .then(response => {
        if (response.status === 200) {
        }
      })
      .catch(error => {
        dispatch(forgotPassFailed(error.message))
      })
  }
}

export const forgotPassStart = () => {
  return {
    type: actionTypes.FORGOTPASS_START
  }
}

export const forgotPassSuccess = () => {
  return {
    type: actionTypes.FORGOTPASS_SUCCESS
  }
}

export const forgotPassFailed = errorMessage => {
  return {
    type: actionTypes.FORGOTPASS_FAILED,
    errorMessage
  }
}

export const autoSignIn = () => {
  // localStorage.setItem('language', language)
  return dispatch => {
    let language = localStorage.getItem('language')
    if (!['en', 'th'].includes(language)) {
      language = 'en'
    }

    let token = localStorage.getItem('authToken')
    let userInfo = localStorage.getItem('userInfo')
    let userPermissions = localStorage.getItem('userPermissions')

    if (token && typeof token === 'string') {
      try {
        token = JSON.parse(token)
      } catch (error) {
        token = null
      }
    }

    if (userInfo && typeof userInfo === 'string') {
      try {
        userInfo = JSON.parse(userInfo)
      } catch (error) {
        userInfo = null
      }
    }

    if (userPermissions && typeof userPermissions === 'string') {
      try {
        userPermissions = JSON.parse(userPermissions)
      } catch (error) {
        userPermissions = null
      }
    }

    dispatch(IntlActions.setLocale(language))
    setTimeout(() => {
      if (token && userInfo && userPermissions) {
        dispatch(signInSuccess(token, userInfo, userPermissions))
      } else {
        if (token) {
          dispatch(signOut(token))
        } else {
          dispatch(signInFailed())
        }
      }
    }, 1000)
  }

  // สำรองเผื่อมี Case ที่ต้องใช้ Refresh token

  // return dispatch => {
  //   if (!token) {
  //     dispatch(signInFailed(''))
  //   }
  //   dispatch(signInStart())
  //   baseAxios
  //     .post('/session', { authToken: token })
  //     .then(response => {
  //       if (response.status === 200) {
  //         let { token, userInfo, userPermission } = response.data

  //         dispatch(IntlActions.setLocale(language))
  //         // add authToken to cookie
  //         localStorage.setItem('authToken', token)

  //         dispatch(signInSuccess(token, userInfo, userPermission))
  //       }
  //     })
  //     .catch(error => dispatch(signInFailed(error.message)))
  // }
}

export const signOut = () => {
  return dispatch => {
    dispatch(signOutStart())
    baseAxios
      .get('/logout')
      .then(response => {
        if (response.status === 200) {
          dispatch(signOutSuccess())
        }
      })
      .catch(error => dispatch(signOutFailed(error.message)))
      .finally(() => {
        dispatch(signOutSuccess())
        localStorage.removeItem('authToken')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userPermissions')
        sessionStorage.removeItem('authToken')
      })
  }
}

export const signOutStart = () => {
  return {
    type: actionTypes.SIGNOUT_START
  }
}

export const signOutSuccess = () => {
  return {
    type: actionTypes.SIGNOUT_SUCCESS
  }
}

export const signOutFailed = errorMessage => {
  return {
    type: actionTypes.SIGNOUT_FAILED,
    errorMessage
  }
}
